import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { CreateTransaction } from 'app/dtos/Transaction/createTransaction';
import { UpdateTransaciton } from 'app/dtos/Transaction/updateTransaction';
import { UpdateTransacitonStatus } from 'app/dtos/Transaction/updateTransactionStatus';
import { UpdateTransacitonExpense } from 'app/dtos/Transaction/updateTransactionExpense';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllOfferTransaction(page, size, search, kindId, status?: number, startfilterDate?: string, endFilterDate?: string, companyId?: number, projectId?: number) {
    const queryParams = new URLSearchParams({
      Page: page.toString(),
      Size: size.toString(),
      Search: search,
      kindId: kindId.toString(),
      Status: status ? status.toString() : '',
      startfilterDate: startfilterDate ? startfilterDate : '',
      endFilterDate: endFilterDate ? endFilterDate : '',
      companyId: companyId ? companyId.toString() : '',
      projectId: projectId ? projectId.toString() : ''
    }).toString();
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      queryString: queryParams
    });
    return await firstValueFrom(observable);
  }

  async getAllTransactionCompany(page, size, kindId, companyId) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "GetTransactionManagementsCompanies",
      queryString: `Page=${page}&Size=${size}&kindId=${kindId}&CompanyId=${companyId}`,

    });
    return await firstValueFrom(observable);
  }

  async createOffer(createTransaction: CreateTransaction) {
    console.log(createTransaction);
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.TransactionManagement
    }, {
      transactionCraetedAt: createTransaction.startDate,
      validityDate: createTransaction.validityDate,
      status: 1,
      transactionPrivateNode: createTransaction.transactionPrivateNode,
      kindId: createTransaction.kindId,
      companyId: createTransaction.companyId,
      appUserId: createTransaction.userId,
      personId: createTransaction.personId,
      requestTaskId: createTransaction.requestTaskId,
      documentNo: createTransaction.docNo,
      projectId: createTransaction.projectId,
      createTransactionProducts: createTransaction.createTransactionProducts,
      descriptionId: createTransaction.descriptionId,
      isEmailSend: createTransaction.isMailConfirmed,
      expenseId: createTransaction.expenseId
    });
    return await firstValueFrom(observable);
  }

  async getByIdTransaction(id: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement
    }, id);
    const result = await firstValueFrom(observable);

    if (!result) {
      console.error('Veri bulunamadı!');
      return null;  // Eğer veri yoksa null dönebilirsiniz
    }

    return result;
  }

  async getByIdTransactionManagementCustomer(id: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "GetByIdTransactionManagementCustomer"
    }, id);
    const result = await firstValueFrom(observable);

    if (!result) {
      console.error('Veri bulunamadı!');
      return null;  // Eğer veri yoksa null dönebilirsiniz
    }

    return result;
  }

  async ByIdUpdateDetailTransaction(id: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "GetByIdTransactionManagementUpdateDetail"
    }, id);
    return await firstValueFrom(observable);
  }

  async ByIdUserDetailTransaction(id: number) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "GetByIdTransactionManagementUserDetail"
    }, id);
    return await firstValueFrom(observable);
  }

  async UpdateTransactionStatus(updateTransactionStatus: UpdateTransacitonStatus) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.TransactionManagement,
      action: "UpdateTransactionManagementStatus"
    },
      {
        id: updateTransactionStatus.id,
        kindId: updateTransactionStatus.kindId,
        status: updateTransactionStatus.status
      });
    return await firstValueFrom(observable);
  }

  async UpdateTransactionStatusCustomer(updateTransactionStatus: UpdateTransacitonStatus) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.TransactionManagement,
      action: "UpdateTransactionManagementStatusCustomer"
    },
      {
        id: updateTransactionStatus.id,
        kindId: updateTransactionStatus.kindId,
        status: updateTransactionStatus.status
      });
    return await firstValueFrom(observable);
  }

  async UpdateDetailTransactionMagenemnt(updateTransaction: UpdateTransaciton) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.TransactionManagement,
    }, {
      id: updateTransaction.id,
      startDate: updateTransaction.startDate,
      endDate: updateTransaction.endDate,
      requestTaskId: updateTransaction.requestTaskId,
      transactionPrivateNode: updateTransaction.transactionPrivateNode,
      personId: updateTransaction.personId,
      documentNo: updateTransaction.docNo,
      projectId: updateTransaction.projectId,
      projectTransactionManagementId: updateTransaction.projectTransactionManagementId ?? null,
      descriptionId: updateTransaction.descriptionId,
      selectedDescriptionId: updateTransaction.selectedDescriptionId,
      expenseId: updateTransaction.expenseId,
      expenseTransactionId: updateTransaction.expenseTransactionId,
      eFaturaId: updateTransaction.eFaturaId
    });
    return await firstValueFrom(observable);
  }

  async UpdateDetailTransactionMagenemntExpense(updateTransactionExpense: UpdateTransacitonExpense) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.TransactionManagement,
      action: "UpdateTransactionManagementExpense"
    },
      {
        id: updateTransactionExpense.id,
        projectId: updateTransactionExpense.projectId,
        docNo: updateTransactionExpense.docNo ?? null,
        description: updateTransactionExpense.description,
        transactionManagementProductId: updateTransactionExpense.transactionManagementProductId,
        taxId: updateTransactionExpense.taxId,
        salePrice: updateTransactionExpense.salePrice,
        expenseId: updateTransactionExpense.expenseId,
        expenseTransactionId: updateTransactionExpense.expenseTransactionId,
        transactionCreatedDate: updateTransactionExpense.date
      });
    return await firstValueFrom(observable);
  }

  async GetTransactionManagementExpenseList(page, size, search, personId, projectId, expenseId, startDate, endDate, vaultId) {
    const params = new URLSearchParams();
    params.set('Page', page.toString());
    params.set('Size', size.toString());
    if (search) params.set('Search', search);
    if (personId && personId !== 0) params.set('PersonId', personId.toString());
    if (projectId && projectId !== 0) params.set('ProjectId', projectId.toString());
    if (expenseId && expenseId !== 0) params.set('ExpenseId', expenseId.toString());
    if (vaultId && vaultId !== 0) params.set('VaultId', vaultId.toString());

    if (startDate) params.set('StartDate', startDate);
    if (endDate) params.set('EndDate', endDate);

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "GetTransactionManagementExpenseList",
      queryString: params.toString()
    });
    return await firstValueFrom(observable);
  }

  async getAllTransactionFixtures(page, size, search) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "GetAllTransactionManagementFixtures",
      queryString: `Page=${page}&Size=${size}&Search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async transactionManagementConfirmed(companyId, no) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "GetConfirmedTransactionManagement",
      queryString: `companyId=${companyId}&no=${no}`
    });
    return await firstValueFrom(observable);
  }

  async EinvoinceCreate(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "EinvoinceCreate"
    }, id);
    return await firstValueFrom(observable);
  }

  async EinvoinceUpdate(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      action: "EinvoinceUpdate"
    }, id);
    return await firstValueFrom(observable);
  }


  async EinvoinceView(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      queryString: `Id=${id}`,
      action: "EinvoinceView"
    });
    return await firstValueFrom(observable);
  }

  async EinvoinceUploadDraftCreate(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.TransactionManagement,
      queryString: `id=${id}`,
      action: "EinvoinceUploadDraftCreate"
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }

}
